import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CircleCrossIcon, HeavyCheckIcon } from 'assets';
import { ApiUser } from 'types';
import { useAppSelector } from 'store';
import { selectUser } from 'store/user';

type AvailableMarkProps = {
  className?: string;
};

export function AvailableMark({ className }: AvailableMarkProps) {
  const user: ApiUser = useAppSelector(selectUser)!;
  const { t, i18n } = useTranslation('providerRoom');
  const isRtl = i18n.dir() === 'rtl';
  const isUnavailable = user.clinicUser.unavailable;

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent={isRtl ? 'flex-end' : 'flex-start'}
      sx={{ width: '100%', marginInline: 0 }}
      className={className}
    >
      {isRtl ? (
        <>
          <Typography component='p' variant='body2' sx={{ width: 'auto !important', textAlign: 'right' }}>
            {isUnavailable ? t('unavailable') : t('available')}
          </Typography>
          {isUnavailable ? (
            <CircleCrossIcon sx={{ color: '#626363', fontSize: '1.6rem', marginInlineStart: '0.6rem' }} />
          ) : (
            <HeavyCheckIcon sx={{ marginInlineStart: '0.6rem' }} />
          )}
        </>
      ) : (
        <>
          {isUnavailable ? (
            <CircleCrossIcon sx={{ color: '#626363', fontSize: '1.6rem', marginInlineEnd: '0.6rem' }} />
          ) : (
            <HeavyCheckIcon sx={{ marginInlineEnd: '0.6rem' }} />
          )}
          <Typography component='p' variant='body2' sx={{ width: 'auto !important', textAlign: 'left' }}>
            {isUnavailable ? t('unavailable') : t('available')}
          </Typography>
        </>
      )}
    </Stack>
  );
}
